import axiosTokenInstance from '../../../services/api/backoffice';

import { SUSPEND_LINE, SUSPEND_LINE_ERROR } from '_models/redux/types';

// Action function
export const actionSuspendLine =
  (sessionIncidence = undefined) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const response = await axiosTokenInstance.post(
        `/api/support/tickets/${sessionIncidence}/actions/suspend-line`,
      );

      const { data } = response || {};

      dispatch({
        type: SUSPEND_LINE,
        payload: data || {},
      });
    } catch (e) {
      dispatch({
        type: SUSPEND_LINE_ERROR,
        payload: e || {},
      });
    }
  };
